import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  numberLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  nameLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  severityLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  severityDropdown: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  laneLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
    minWidth: "300px",
  },
  modeLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },  
  deviceLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
    minWidth: "300px",
  },
  gateLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },   
  outputLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  }, 
  stateLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },  
  settingLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },  
  valueLabel: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },  
  laneDropdown:{
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },  
  modeDropdown:{
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  deviceDropdown:{
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },  
  gateDropdown:{
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  outputDropdown:{
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },  
  stateDropdown:{
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  settingDropdown:{
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  valueDropdown:{
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  tooltip:{
    fontSize: "0.7rem", 
    fontWeight: 500,
  },
  container: {
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(2),
    },
  },
  actionContainer: {    
  display: "flex",
  justifyContent: "flex-end",
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
  marginRight: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  },
  actionHeader: {
    margin: "10px",
  },
  actionIcon: {
    margin: "10px",
    fontWeight: "normal",
  },
  actionText: {
    margin: "10px",
    marginTop: "1px",
    fontWeight: "normal",
  },
  cancelBtn: {
    float: "right",
  },
  saveBtn: {
    float: "right",
  },
  drawerContainer: {
    padding: theme.spacing(2),
    overflowX: "hidden", 
    width: "100%",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  buttonContainer: {
    margin: theme.spacing(2),
  },
  btnControl: {
    margin: theme.spacing(1),
  },
  tableContainer: {
    overflowY: "auto",
    overflowX: "auto",
  },
  title: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  DrawerTitle: {
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(1),
      textAlign: "center",
    },
  },
  table: {
    tableLayout: "fixed",
    [theme.breakpoints.down("md")]: {
      tableLayout: "auto",
    },
  },
  tableCells: {
    alignContent: "center",
    justifyContent: "center",
  },
  actionTableCell: {
    [theme.breakpoints.down("sm")]: {
      minWidth: "200px",
    },
  },
  deleteButton: {
    marginLeft: theme.spacing(1),
  },
  BoardDropdown: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  pinField: {
    paddingLeft: theme.spacing(1),
  },
  addButtonGrid: {
    height: "50px",
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
  },
  radioControls: {
    marginTop: theme.spacing(1),
  },
  systemEventLabel: {
    paddingTop: "10px",
    paddingLeft: "18px",
  },
  selectError: {
    color: "#f44336",
    marginLeft: "10px",
    fontSize: ".85em",
    marginTop: "5px",
  },
  mobileNumber: {
    maxWidth: "17em",
  },
  mobileName: {
    minWidth: "17em",
  },
  formError: {
    marginLeft: "10px",
    fontSize: ".85em",
    marginTop: "5px",
    maxWidth: "17em",
  },
  tagbutton: {
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(0.75),
    fontSize: "0.7rem",
    backgroundColor: theme.palette.amano.base.secondary.main,
    '&:hover': {backgroundColor: theme.palette.amano.base.secondary.light,},
  },
  textNote:{
    display: "flex",
    alignItems: "center",    
    paddingTop: 8,
  },
  noteFormat:{
    color:theme.palette.warning.main,   
  },
  textDrawerContainer: {
    padding: theme.spacing(2),
    minWidth: "400px",
    maxWidth: "600px",
    overflowX: "hidden", 
    width: "100%",
  },
}));
